// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PYA7","questions":"styles_questions__EBwwo","footer":"styles_footer__1xEWC"};